require("bootstrap");
require("../app");

require("../promo_webpay");
require("../modal_promocion");
require("@fancyapps/fancybox");
require("./scripts");



$(".cerrar-modal-modelo").on('click', function (e) {
    setTimeout(function () {
        document.getElementById("contacto").scrollIntoView({ behavior: "smooth" });
    }, 500);
})
$(".cerrar-modal-modelo-tour").on('click', function (e) {
    setTimeout(function () {
        document.getElementById("recorrido").scrollIntoView({ behavior: "smooth" });
    }, 500);
})


require("./sliders");
require("./js-slider.min");